import { getName } from "./getName";

export const getNameWithPercentageSplit = (
  person,
  splitPercent,
  isSharedEqually,
  totalBeneficiaries
) => {
  const fullName = getName(person);
  const formatOutput = (name, splitInfo = "") =>
    `<div1> ${name} ${
      splitInfo !== ""
        ? `- <div2 className="text-theme-text-tertiary">${splitInfo}</div2>`
        : ""
    }</div1>`;

  // Handle scenarios based on the shared equally flag and split percent value.
  if (isSharedEqually?.toUpperCase() === "Y") {
    if (totalBeneficiaries === 1) {
      return formatOutput(fullName, "100%");
    } else {
      return formatOutput(fullName, "Shared Equally");
    }
  } else if (splitPercent === "0.00" || !splitPercent) {
    return formatOutput(fullName);
  } else {
    return formatOutput(fullName, `${splitPercent}%`);
  }
};
